import { catalogMailingListsConstants } from '../constants/catalog_mailing_lists';

export function catalogMailingLists(state = {catalogMailingList: {}, mailingListRecipients: {}}, action) {
	switch (action.type) {
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_REQUEST:
			return {
				...state,
				loading: true
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_SUCCESS:
			return {
				
				...state,
				loading: false,
				catalogMailingLists: action.catalogMailingLists
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_REQUEST:
			return {
				...state,
				detailsLoading: true
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_SUCCESS:
			if(!action.id)
				return {...state};
				
			let catalogMailingList = state.catalogMailingList;
			catalogMailingList[action.id] = action.catalogMailingList;
			return {
				...state,
				detailsLoading: false,
				catalogMailingList
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_DETAILS_FAILURE:
			return {
				...state,
				detailsLoading: false,
				error: action.error
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_RECIPIENTS_REQUEST:
			return {
				...state,
				recipientsLoading: true
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_RECIPIENTS_SUCCESS:
			let mailingListRecipients = state.mailingListRecipients;
			mailingListRecipients[action.id] = action.recipients;
			return {
				...state,
				recipientsLoading: false,
				mailingListRecipients
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LIST_RECIPIENTS_FAILURE:
			return {
				...state,
				recipientsLoading: false,
				error: action.error
			};
			
		case catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_REQUEST:
			return {
				...state,
				catalogMailingListLoading: true
			};
		case catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_SUCCESS:
			return {
				
				...state,
				catalogMailingListLoading: false,
			};
		case catalogMailingListsConstants.ADD_CATALOG_MAILING_LIST_FAILURE:
			return {
				...state,
				catalogMailingListLoading: false,
			};

		case catalogMailingListsConstants.ADD_RECIPIENT_REQUEST:
			return {
				...state,
				recipientLoading: true,
			};
		case catalogMailingListsConstants.ADD_RECIPIENT_SUCCESS:
			return {
				
				...state,
				recipientLoading: false,
			};
		case catalogMailingListsConstants.ADD_RECIPIENT_FAILURE:
			return {
				...state,
				recipientLoading: false,
			};
			
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_BY_RECIPIENT_REQUEST:
			return {
				...state,
				listsByRecipientLoading: true
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_BY_RECIPIENT_SUCCESS:
			return {
				
				...state,
				listsByRecipientLoading: false,
				listsByRecipient: action.catalogMailingLists
			};
		case catalogMailingListsConstants.GET_CATALOG_MAILING_LISTS_BY_RECIPIENT_FAILURE:
			return {
				...state,
				listsByRecipientLoading: false,
				error: action.error
			};            
			
		default:
			return state
	}
} 

